export const brl = (v) =>
  (v == null || isNaN(v) ? 0 : Number(v)).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

export const num = (v, d = 0) =>
  (v == null || isNaN(v) ? 0 : Number(v)).toLocaleString("pt-BR", {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const dt = new Date(iso);
  if (isNaN(dt)) return "—";
  return dt.toLocaleDateString("pt-BR");
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const dt = new Date(iso);
  if (isNaN(dt)) return "—";
  return dt.toLocaleDateString("pt-BR") + " " + dt.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
};

export const STATUS = {
  CRITICO: { label: "Comprar Agora", short: "Crítico", dot: "🔴", color: "text-rose-300", bg: "bg-rose-950/60", border: "border-rose-700/70" },
  ATENCAO: { label: "Comprar em Breve", short: "Atenção", dot: "🟠", color: "text-amber-300", bg: "bg-amber-950/50", border: "border-amber-700/60" },
  ADEQUADO: { label: "Estoque Adequado", short: "Adequado", dot: "🟢", color: "text-emerald-300", bg: "bg-emerald-950/50", border: "border-emerald-700/60" },
  EXCESSO: { label: "Excesso de Estoque", short: "Excesso", dot: "⚪", color: "text-slate-300", bg: "bg-slate-800/60", border: "border-slate-600/60" },
};

export const CRIT = {
  ALTA: { label: "Alta", color: "text-rose-300", bg: "bg-rose-950/50 border-rose-800/60" },
  MEDIA: { label: "Média", color: "text-amber-300", bg: "bg-amber-950/40 border-amber-800/50" },
  BAIXA: { label: "Baixa", color: "text-sky-300", bg: "bg-sky-950/40 border-sky-800/50" },
};

export const locString = (l) =>
  !l ? "—" : [l.almoxarifado, l.corredor, l.estante, l.prateleira, l.caixa].filter(Boolean).join(" · ");
